import { Controller, UseFormReturn } from 'react-hook-form';
import { When } from 'react-if';
import cns from 'classnames';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { Select, TextField } from '@zep/ui';
import { StoreCategoryString, useStoreAppSubCategories } from '../../../../consts';
import { useMyApps, ZepApp, ZepAppType } from '../../../../services';
import { StoreAppUploadDataType, UploadCommonFormProps } from '../../../../types/StoreTypes';
import ContentSelectionGrid from './ContentSelectionGrid';
import S from './UploadCommonForm.module.scss';
import UploadThumbnailCard from './UploadThumbnailCard';

/**
 * 앱/미니 게임 공통정보 입력 폼
 * @param props
 * @constructor
 */
const UploadCommonAppForm = (props: UploadCommonFormProps) => {
  const {
    isEditBlocked,
    commonForm
  } = props;
  const router = useRouter();
  const {
    t
  } = useTranslation(['store']);
  const uploadType: string = typeof router.query.type === 'string' ? router.query.type : StoreCategoryString.app;
  const editHashId = router.query.edit?.toString() ?? '';
  const {
    control,
    formState: {
      errors
    }
  } = commonForm as UseFormReturn<StoreAppUploadDataType>;

  // 내가 등록한 앱 목록 인출
  const appsSourceListQuery = useMyApps();
  const appSubCategoryOptions = useStoreAppSubCategories().slice(1).map(subCategory => ({
    name: subCategory.name,
    value: subCategory.value
  }));
  return <div className={S.upload_form} data-sentry-component="UploadCommonAppForm" data-sentry-source-file="UploadCommonAppForm.tsx">
      <When condition={uploadType === StoreCategoryString.app} data-sentry-element="When" data-sentry-source-file="UploadCommonAppForm.tsx">
        {/*앱 카테고리 선택(앱인 경우에만 노출)*/}
        <div className={cns([S.upload_form_row, S.half_width])}>
          <TextField label={t('store:store_app_category')} data-sentry-element="TextField" data-sentry-source-file="UploadCommonAppForm.tsx">
            <Controller control={control} name="subCategory" render={({
            field: {
              value,
              onChange
            }
          }) => <Select defaultValue={appSubCategoryOptions.find(option => option.value === value)} onChange={
          // @ts-ignore
          selectedCategory => onChange(selectedCategory.value)} placeholder={t('store:store_category_default')} options={appSubCategoryOptions} width={'500'} size={'md'} />} data-sentry-element="Controller" data-sentry-source-file="UploadCommonAppForm.tsx" />
            {!!errors.subCategory && <div className={S.error_text}>{errors.subCategory?.message}</div>}
          </TextField>
        </div>
      </When>

      {/* 앱 아이콘 */}
      <div className={cns([S.upload_form_row])}>
        <label>
          {t('store:store_something_icon', {
          x: uploadType === StoreCategoryString.app ? t('store:store_asset_app') : t('store:store_asset_game')
        })}
          <small>{t('store:store_accept_must_size')}</small>
        </label>
        <Controller control={control} name="iconImageKey" render={({
        field: {
          value,
          onChange
        }
      }) => <UploadThumbnailCard thumbnail={value ?? ''} thumbnailKey={'icon'} onThumbnailUpload={newThumbnail => onChange(newThumbnail as string)} disabled={isEditBlocked} />} data-sentry-element="Controller" data-sentry-source-file="UploadCommonAppForm.tsx" />
        {!!errors.iconImageKey && <div className={S.error_text}>{errors.iconImageKey?.message}</div>}
      </div>

      {/* 앱 선택 */}
      <div className={S.upload_form_row}>
        <label>
          {t('store:store_something_select', {
          x: uploadType === StoreCategoryString.app ? t('store:store_asset_app') : t('store:store_asset_game')
        })}
        </label>
        <Controller control={control} name="sourceAppHashId" render={({
        field: {
          value,
          onChange
        }
      }) => <ContentSelectionGrid contents={appsSourceListQuery.isSuccess && appsSourceListQuery.data.apps.filter((app: ZepApp) => app.type === (uploadType === StoreCategoryString.game ? ZepAppType.MiniGame : ZepAppType.Sidebar)) || []} onContentSelect={(spaceId: string) => onChange(spaceId)} selectedContentHashId={value} disabled={!!editHashId || isEditBlocked} isAppContent />} data-sentry-element="Controller" data-sentry-source-file="UploadCommonAppForm.tsx" />
        {!!errors.sourceAppHashId && <div className={S.error_text}>{errors.sourceAppHashId?.message}</div>}
      </div>
    </div>;
};
export default UploadCommonAppForm;